import { XMarkIcon } from "@heroicons/react/24/outline";
import Input from "src/components/Inputs/Input";
import Modal from "src/components/Modal";
import { useInfo } from "src/hooks/useData";
import { convertToMoYr } from "src/utils";
import YearlyIncreaseComponent from "../YearlyIncrease";

const CurrentSpendingModal = ({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: any;
}) => {
  const { data, setField } = useInfo();
  const spending = data.spending;
  const setSpending = setField("spending");

  return (
    <>
      <Modal
        isOpen={open}
        onClose={() => {
          setOpen(false);
        }}
      >
        <div className="flex justify-between mb-5">
          <div className="text-lg font-semibold w-96 text-left">
            Current Spending
            <div className="text-sm font-normal italic text-gray-500 mt-1">
              These changes will affect Spending for ALL scenarios
            </div>
          </div>
          <XMarkIcon
            className="h-6 w-6 cursor-pointer"
            onClick={() => setOpen(false)}
          />
        </div>

        <div className="flex justify-between">
          <div className="flex flex-col gap-4 w-full text-left">
            <div className="">
              <Input
                label="Amount (Today's Dollars)"
                vertical
                size="lg"
                value={
                  spending.newCurrentSpending
                    ? spending.newCurrentSpending
                    : convertToMoYr(spending.currentSpending)
                }
                setValue={(v) =>
                  setSpending({ ...spending, newCurrentSpending: v })
                }
                subtype="mo/yr"
              />
            </div>
            <div className=" ">
              <YearlyIncreaseComponent
                labels
                increase={spending.yearlyIncrease}
                setYearlyIncrease={(y) =>
                  setSpending({
                    ...spending,
                    yearlyIncrease: y,
                  })
                }
              />
            </div>
            {data.people.map((p, i) => (
              <div>
                <Input
                  vertical
                  size="lg"
                  value={spending.decreaseAtDeath[i]}
                  setValue={(value: number) =>
                    setSpending({
                      ...spending,
                      decreaseAtDeath: spending.decreaseAtDeath.map(
                        (val, ind) => (ind == i ? value : val),
                      ) as [number, number],
                    })
                  }
                  subtype="percent"
                  label={`Decrease at ${p.name} Death`}
                />
              </div>
            ))}
          </div>
        </div>
      </Modal>
    </>
  );
};

export default CurrentSpendingModal;
